import {PercentageCircle} from '@github-ui/percentage-circle'
import {Box, Label, Text} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import type {TaskListStatus$key} from './__generated__/TaskListStatus.graphql'
import {LABELS} from '../../constants/labels'

type TaskListStatusProps = {
  taskListStatus: TaskListStatus$key
}

export function TaskListStatus({taskListStatus}: TaskListStatusProps) {
  const {total, completed} = useFragment(
    graphql`
      fragment TaskListStatus on TrackedIssueCompletion {
        completed
        total
      }
    `,
    taskListStatus,
  )

  const progress = completed / total

  if (total === 0 || Object.is(NaN, progress)) return null

  return (
    <>
      <Box
        sx={{
          whiteSpace: 'nowrap',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          ml: 1,
          verticalAlign: 'middle',
        }}
      >
        <Box as="span" sx={{display: 'inline-flex', alignItems: 'center', gap: 1}}>
          <Label sx={{color: 'fg.default'}}>
            <PercentageCircle progress={progress} radius={5} isSuccess />
            <Text sx={{ml: 1, color: 'fg.muted', fontWeight: 'normal', fontSize: 0}}>
              {LABELS.tasks(completed, total)}
            </Text>
          </Label>
        </Box>
      </Box>
    </>
  )
}

try{ TaskListStatus.displayName ||= 'TaskListStatus' } catch {}